/*
 * YAMIWARD — RESIDENT REGISTRATION (住民登録)
 * Issues a canvas-drawn Ward resident permit: handle + faction affinity in,
 * 1080×680 ID-card PNG out. Text/kanji only — canvas never taints.
 *
 * Status ladder (the soft email gate): permits print PROVISIONAL until the
 * visitor has joined the Ward list (newsletter form reloads the page with
 * ?customer_posted=true → we set yw_resident_registered), after which they
 * print ACKNOWLEDGED. Night Parade issues get a collectible night stamp.
 */
(function () {
    'use strict';

    var STORE_URL = 'yamiward.com';
    var REG_KEY = 'yw_resident_registered';
    var CARD_KEY = 'yw_resident';

    var FACTION_META = {
        ward: { glyph: '闇', zone: 'WARD ZERO — THE GATE' },
        kage:     { glyph: '影', zone: 'BLOCKS 影-1 TO 影-4 (NIGHT)' },
        oniworks: { glyph: '鬼', zone: 'FOUNDRY WARD — BAY 03' },
        yurei:    { glyph: '幽', zone: 'NO FIXED ADDRESS (APPROVED)' },
        phantom:  { glyph: '幻', zone: 'AIRFIELD SECTOR 7' }
    };

    var host = null;
    var selectedFaction = 'ward';

    // Mark the visitor as a registered resident once the real newsletter form
    // has posted (Shopify reloads with ?customer_posted=true).
    try {
        if (window.location.search.indexOf('customer_posted=true') !== -1) {
            localStorage.setItem(REG_KEY, '1');
        }
    } catch (e) { /* ignore */ }

    function isRegistered() {
        try { return localStorage.getItem(REG_KEY) === '1'; } catch (e) { return false; }
    }

    function el(tag, cls, text) {
        var node = document.createElement(tag);
        if (cls) node.className = cls;
        if (text !== undefined) node.textContent = text;
        return node;
    }

    function pad(n) { return (n < 10 ? '00' : '0') + n; }

    function cleanHandle(raw) {
        var h = String(raw || '').trim();
        if (h && h.charAt(0) !== '@') h = '@' + h;
        h = h.replace(/[^@a-zA-Z0-9_]/g, '').slice(0, 24);
        return h.length > 1 ? h : '';
    }

    // djb2 — deterministic permit numbers and barcode patterns per handle.
    function hash(str) {
        var h = 5381;
        for (var i = 0; i < str.length; i++) h = ((h << 5) + h + str.charCodeAt(i)) >>> 0;
        return h;
    }

    function permitNo(handle) {
        var h = hash(handle.toLowerCase());
        return 'YW-' + String(h % 10000).padStart(4, '0') + '-' + String(Math.floor(h / 10000) % 10000).padStart(4, '0');
    }

    // Bloodline on record (set by clans.js) — printed on the permit.
    var CLAN_NAMES = {
        yukionna: 'YUKIONNA 雪女', oni: 'ONI 鬼', kitsune: 'KITSUNE 狐', kodama: 'KODAMA 木霊',
        kappa: 'KAPPA 河童', ameonna: 'AMEONNA 雨女', hitodama: 'HITODAMA 人魂', raiju: 'RAIJU 雷獣',
        tsukiusagi: 'TSUKIUSAGI 月兎', bakeneko: 'BAKENEKO 化け猫', tengu: 'TENGU 天狗', ryu: 'RYU 龍'
    };

    function bloodlineOnRecord() {
        try {
            var c = JSON.parse(localStorage.getItem('yw_clan') || 'null');
            if (c && c.key && CLAN_NAMES[c.key]) return CLAN_NAMES[c.key];
        } catch (e) { /* ignore */ }
        return null;
    }

    function quizMatch() {
        try {
            var saved = JSON.parse(localStorage.getItem('yw_quiz_result') || 'null');
            if (saved && saved.n && window.YW_CODEX) {
                var list = window.YW_CODEX.entries;
                for (var i = 0; i < list.length; i++) if (list[i].n === saved.n) return list[i];
            }
        } catch (e) { /* ignore */ }
        return null;
    }

    /* ---------- Form UI ---------- */

    function buildForm() {
        host.innerHTML = '';
        var box = el('div', 'resident-box');
        box.appendChild(el('div', 'quiz-kicker', 'RECORDS OFFICE — FORM 住-01 · RESIDENT PERMIT APPLICATION'));

        var saved = null;
        try { saved = JSON.parse(localStorage.getItem(CARD_KEY) || 'null'); } catch (e) { /* ignore */ }

        // Handle input (defaults: saved card > arcade/board handle)
        var defHandle = (saved && saved.handle) || '';
        if (!defHandle) {
            try { defHandle = localStorage.getItem('yw_handle') || ''; } catch (e) { /* ignore */ }
        }
        var row = el('div', 'resident-row');
        var label = el('label', 'resident-label', 'HANDLE:');
        label.setAttribute('for', 'resident-handle');
        row.appendChild(label);
        var input = el('input', 'signup-input resident-input');
        input.id = 'resident-handle';
        input.type = 'text';
        input.maxLength = 24;
        input.placeholder = '@your_handle';
        input.value = defHandle;
        row.appendChild(input);
        box.appendChild(row);

        // Affinity picker
        var match = quizMatch();
        selectedFaction = (saved && saved.faction) || (match ? match.faction : 'ward');
        box.appendChild(el('div', 'resident-label resident-affinity-label', 'AFFINITY:'));
        var picker = el('div', 'resident-factions');
        var factions = window.YW_CODEX ? window.YW_CODEX.factions : {};
        Object.keys(FACTION_META).forEach(function (key) {
            var f = factions[key];
            if (!f) return;
            var b = el('button', 'resident-faction-btn' + (key === selectedFaction ? ' active' : ''));
            b.type = 'button';
            b.style.setProperty('--codex-accent', f.color);
            b.appendChild(el('span', 'resident-faction-glyph', FACTION_META[key].glyph));
            b.appendChild(document.createTextNode(' ' + f.label));
            b.addEventListener('click', function () {
                selectedFaction = key;
                picker.querySelectorAll('.resident-faction-btn').forEach(function (x) { x.classList.remove('active'); });
                b.classList.add('active');
            });
            picker.appendChild(b);
        });
        box.appendChild(picker);

        if (match) {
            box.appendChild(el('p', 'resident-filematch', 'Diagnosis on file: ENTRY ' + pad(match.n) + ' — ' + match.name + '. It will be printed on your permit.'));
        }

        var status = el('p', 'resident-status-note');
        if (isRegistered()) {
            status.textContent = 'Registration verified — your permit prints with ACKNOWLEDGED status.';
            status.classList.add('registered');
        } else {
            status.innerHTML = 'Unregistered applicants receive <strong>PROVISIONAL</strong> permits. <a href="#signup">Join the Ward list</a>, then re-issue for full ACKNOWLEDGED status.';
        }
        box.appendChild(status);

        var issue = el('button', 'btn btn-primary resident-issue-btn', 'ISSUE MY PERMIT');
        issue.addEventListener('click', function () {
            var handle = cleanHandle(input.value);
            if (!handle) {
                input.classList.add('resident-input-error');
                input.focus();
                setTimeout(function () { input.classList.remove('resident-input-error'); }, 1200);
                return;
            }
            try {
                localStorage.setItem(CARD_KEY, JSON.stringify({ handle: handle, faction: selectedFaction }));
                localStorage.setItem('yw_handle', handle);
            } catch (e) { /* ignore */ }
            if (document.fonts && document.fonts.ready) {
                document.fonts.ready.then(function () { showCard(handle, selectedFaction); });
            } else {
                showCard(handle, selectedFaction);
            }
        });
        box.appendChild(issue);

        host.appendChild(box);
    }

    /* ---------- Card preview + actions ---------- */

    var lastCanvas = null;

    function showCard(handle, factionKey) {
        var canvas = drawCard(handle, factionKey);
        lastCanvas = canvas;
        host.innerHTML = '';
        var box = el('div', 'resident-box');
        box.appendChild(el('div', 'quiz-kicker', 'PERMIT ISSUED — ' + permitNo(handle)));

        var wrap = el('div', 'resident-card-wrap');
        canvas.className = 'resident-card-canvas';
        wrap.appendChild(canvas);
        box.appendChild(wrap);

        var actions = el('div', 'quiz-actions');

        var dl = el('button', 'btn btn-primary', 'DOWNLOAD PERMIT');
        dl.addEventListener('click', function () {
            var a = document.createElement('a');
            a.download = 'yamiward-resident-' + handle.replace(/[^a-z0-9_]/gi, '').toLowerCase() + '.png';
            a.href = canvas.toDataURL('image/png');
            a.click();
        });
        actions.appendChild(dl);

        var share = el('button', 'btn btn-secondary', 'SHARE');
        share.addEventListener('click', function () {
            var url = 'https://' + STORE_URL + '/#resident';
            var text = 'Officially a resident of the Yamiward. Permit ' + permitNo(handle) + '. Get your papers:';
            if (navigator.share) {
                navigator.share({ title: 'Yamiward — Resident Permit', text: text, url: url }).catch(function () { /* cancelled */ });
            } else if (navigator.clipboard) {
                navigator.clipboard.writeText(text + ' ' + url).then(function () {
                    var old = share.textContent;
                    share.textContent = 'COPIED!';
                    setTimeout(function () { share.textContent = old; }, 1600);
                });
            }
        });
        actions.appendChild(share);

        var redo = el('button', 'btn btn-secondary', 'RE-ISSUE');
        redo.addEventListener('click', buildForm);
        actions.appendChild(redo);

        box.appendChild(actions);

        if (!isRegistered()) {
            var upsell = el('p', 'resident-status-note');
            upsell.innerHTML = 'This permit is <strong>PROVISIONAL</strong>. <a href="#signup">Register with the Ward list</a> and re-issue to hold ACKNOWLEDGED status.';
            box.appendChild(upsell);
        }

        host.appendChild(box);
        box.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    /* ---------- Canvas ---------- */

    function roundRect(ctx, x, y, w, h, r) {
        ctx.beginPath();
        ctx.moveTo(x + r, y);
        ctx.arcTo(x + w, y, x + w, y + h, r);
        ctx.arcTo(x + w, y + h, x, y + h, r);
        ctx.arcTo(x, y + h, x, y, r);
        ctx.arcTo(x, y, x + w, y, r);
        ctx.closePath();
    }

    function drawCard(handle, factionKey) {
        var W = 1080, H = 680;
        var factions = window.YW_CODEX.factions;
        var f = factions[factionKey];
        var meta = FACTION_META[factionKey];
        var night = !!window.YW_NIGHT;
        var registered = isRegistered();
        var match = quizMatch();

        var canvas = document.createElement('canvas');
        canvas.width = W; canvas.height = H;
        var ctx = canvas.getContext('2d');

        // Base
        ctx.fillStyle = night ? '#04040A' : '#05050A';
        ctx.fillRect(0, 0, W, H);
        var grad = ctx.createLinearGradient(0, 0, W, H);
        grad.addColorStop(0, 'rgba(255,255,255,0.02)');
        grad.addColorStop(1, 'rgba(0,0,0,0)');
        ctx.fillStyle = grad;
        ctx.fillRect(0, 0, W, H);

        // Frame
        ctx.strokeStyle = f.color;
        ctx.lineWidth = 5;
        roundRect(ctx, 24, 24, W - 48, H - 48, 14);
        ctx.stroke();
        ctx.strokeStyle = 'rgba(255,255,255,0.1)';
        ctx.lineWidth = 1;
        roundRect(ctx, 38, 38, W - 76, H - 76, 10);
        ctx.stroke();

        // Header band
        ctx.fillStyle = 'rgba(255,255,255,0.04)';
        ctx.fillRect(40, 40, W - 80, 78);
        ctx.textAlign = 'left';
        ctx.textBaseline = 'alphabetic';
        ctx.fillStyle = '#F3F3F5';
        ctx.font = '900 34px Outfit, sans-serif';
        ctx.fillText('YAMIWARD — RESIDENT PERMIT', 70, 90);
        ctx.textAlign = 'right';
        ctx.fillStyle = '#E51E25';
        ctx.font = '900 30px "Noto Sans JP", sans-serif';
        ctx.fillText('闇区住民証', W - 70, 90);

        // Portrait panel
        var px = 70, py = 150, pw = 250, ph = 330;
        ctx.fillStyle = 'rgba(255,255,255,0.03)';
        ctx.fillRect(px, py, pw, ph);
        ctx.strokeStyle = 'rgba(255,255,255,0.14)';
        ctx.strokeRect(px, py, pw, ph);
        ctx.save();
        ctx.globalAlpha = 0.85;
        ctx.fillStyle = f.color;
        ctx.font = '900 170px "Noto Sans JP", sans-serif';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(meta.glyph, px + pw / 2, py + ph / 2 - 16);
        ctx.restore();
        ctx.fillStyle = 'rgba(243,243,245,0.45)';
        ctx.font = '400 15px "Space Mono", monospace';
        ctx.textAlign = 'center';
        ctx.fillText('NO PHOTOGRAPH —', px + pw / 2, py + ph - 44);
        ctx.fillText('SUBJECT DOES NOT ALWAYS RENDER', px + pw / 2, py + ph - 22);

        // Fields
        var fx = 370, fy = 180;
        var rows = [
            ['HANDLE', handle],
            ['AFFINITY', f.label],
            ['ZONE', meta.zone],
            ['PERMIT NO', permitNo(handle)],
            ['ISSUED', new Date().toISOString().slice(0, 10) + ' · EXPIRES: NEVER (SEE TERMS)']
        ];
        if (match) rows.splice(3, 0, ['FILE MATCH', 'ENTRY ' + pad(match.n) + ' — ' + match.name]);
        var blood = bloodlineOnRecord();
        if (blood) rows.splice(2, 0, ['BLOODLINE', blood]);

        ctx.textAlign = 'left';
        // 7+ rows (bloodline + file match) must still clear the barcode at y=550
        var rowGap = rows.length >= 7 ? 48 : 62;
        var valGap = rows.length >= 7 ? 26 : 30;
        rows.forEach(function (r) {
            ctx.fillStyle = 'rgba(243,243,245,0.45)';
            ctx.font = '700 16px "Space Mono", monospace';
            ctx.fillText(r[0], fx, fy);
            ctx.fillStyle = '#F3F3F5';
            ctx.font = (r[0] === 'HANDLE' ? '900 34px Outfit, sans-serif' : '400 22px "Space Mono", monospace');
            ctx.fillText(r[1], fx, fy + (r[0] === 'HANDLE' ? 40 : valGap));
            fy += (r[0] === 'HANDLE' ? 78 : rowGap);
        });

        // Status stamp
        var stampText = registered ? 'ACKNOWLEDGED' : 'PROVISIONAL';
        var stampColor = registered ? f.color : 'rgba(243,243,245,0.55)';
        ctx.save();
        ctx.translate(W - 210, 190);
        ctx.rotate(-0.12);
        ctx.strokeStyle = stampColor;
        ctx.lineWidth = 3;
        ctx.font = '900 26px "Space Mono", monospace';
        ctx.textAlign = 'center';
        var tw = ctx.measureText(stampText).width;
        ctx.strokeRect(-tw / 2 - 16, -26, tw + 32, 44);
        ctx.fillStyle = stampColor;
        ctx.fillText(stampText, 0, 6);
        ctx.restore();

        // Night Parade issue stamp (collectible variant)
        if (night) {
            ctx.save();
            ctx.translate(W - 210, 265);
            ctx.rotate(0.08);
            ctx.strokeStyle = '#B7A7F0';
            ctx.fillStyle = '#B7A7F0';
            ctx.lineWidth = 2;
            ctx.font = '700 15px "Space Mono", monospace';
            ctx.textAlign = 'center';
            var nt = 'ISSUED DURING THE NIGHT PARADE';
            var ntw = ctx.measureText(nt).width;
            ctx.strokeRect(-ntw / 2 - 12, -18, ntw + 24, 32);
            ctx.fillText(nt, 0, 4);
            ctx.restore();
        }

        // Barcode strip (deterministic from handle)
        var bh = hash(handle + factionKey);
        var bx = 70, by = H - 130;
        ctx.fillStyle = 'rgba(243,243,245,0.8)';
        for (var i = 0; i < 60; i++) {
            var wbar = ((bh >> (i % 28)) & 1) ? 5 : 2;
            ctx.fillRect(bx, by, wbar, 46);
            bx += wbar + 4;
        }
        ctx.fillStyle = 'rgba(243,243,245,0.4)';
        ctx.font = '400 14px "Space Mono", monospace';
        ctx.textAlign = 'left';
        ctx.fillText('ALL FOUR LINES TERMINATE AT THE GATE · FARE DEBT: YES', 70, H - 60);

        // Signature + URL
        ctx.textAlign = 'right';
        ctx.fillStyle = 'rgba(243,243,245,0.55)';
        ctx.font = 'italic 400 18px Outfit, sans-serif';
        ctx.fillText('Records Office, Ward Zero', W - 70, H - 88);
        ctx.fillStyle = f.color;
        ctx.font = '700 16px "Space Mono", monospace';
        ctx.fillText(STORE_URL + '/#resident', W - 70, H - 60);

        return canvas;
    }

    /* ---------- Init ---------- */

    function init() {
        host = document.getElementById('resident-stage');
        if (!host || !window.YW_CODEX) return;
        buildForm();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
